import { InfoStruct, MemberStruct } from '@/types/meeting';

export function baseConvert(res: defs.api.TheJSONResponseObjectWrapperClasses, convertFn: (data: any) => any) {
  if (res.status === 1 || res.status === 200) {
    return {
      ...res,
      data: convertFn(res.data),
    };
  }
  return res;
}

export function convertMeetingInfo(info: defs.api.WebConferenceInformation | undefined): InfoStruct | null {
  if (info) {
    return {
      ...info,
      appKey: info.yxAuth?.yxMeetingAppKey!,
      // 取消全体静音人数上限
      audioOnTotal: info.controlStatus?.mikeOnLimit,
      // 云信会议名，随机字符串
      channelName: info.channelName,
      cid: info.channelId,
      // 房间创建时间
      createtime: info.beginTime,
      // 房间结束时间
      destroytime: info.endTime,
      // 会议ID
      meetingId: info.meetingId!,
      // 会议名称
      meetingName: info.meetingName!,
      members: info.members?.map(convertMemberInfo) || [],
      // 房间模式【1：双人、2：多人、3：日历】
      mode: info.mode,
      // 是否只能主持人邀请
      onlyOwnerInvite: info.controlStatus?.invitePrivilege === 2,
      // 组织者uid，即主持人uid
      ownerUid: info.ownerUid,
      // 加入房间默认是否静音
      quiet: info.controlStatus?.muteEnter,
      // 会议开始时间，日程会议才有该字段
      scheduleStartTime: info.scheduleStartTime,
      // 屏幕共享人，空字符串(‘’)表示没有共享人，否则是共享人的uid
      shareUid: info.screenShareStatus?.shareUid,
      // 房间状态【1：初始状态，2：进行中，3：正常结束，4：异常结束，5：解散】
      status: info.status,
      // 云信SDK - token，根据调用接口的用户获取
      token: info.yxAuth?.yxMeetingToken || info.chatRoomStatus?.imToken,
      // 会议类型，1-音频，2-视频
      type: info.type,
      // 是否允许web端入会
      webEnabled: info.webEntranceStatus?.webEnabled,
      // web端入会链接
      webMeetingLink: info.webEntranceStatus?.webMeetingLink,
      // 是否允许聊天室
      chatRoomEnabled: !!info.chatRoomStatus?.chatRoomEnabled,
    };
  }
  return null;
}

// 转换人员信息
export function convertMemberInfo(info: defs.api.ParticipantsInformationV3 | undefined): MemberStruct | null {
  if (info) {
    return {
      mid: `${info.uid}${info.deviceId}`,
      ...info,
    };
  }
  return null;
}
